import { Component } from '@angular/core';
import { LoginService } from '../shared/services/login.service';
import { Router } from '@angular/router';
import { TranslateDirective } from '../shared/translate.directive';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ErrorComponent } from '../shared/error/error.component';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateDirective, ErrorComponent],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.less'
})
export class ResetPasswordComponent {

  constructor(private service: LoginService, private router: Router) {
  }

  model: any = {
    Email: null,
    Code: null,
    NewPassword: null,
    ConfirmPassword: null
  }
  successfulReg = false;
  hasErrors = false;
  errors: any;
  ngOnInit() {

  }

  resetPassword() {
    this.successfulReg = false;
    this.hasErrors = false;
    this.errors = null;
    this.model.Code = this.model?.Code?.trim();
    this.service.resetPassword(this.model).subscribe({
      next: res => {
        if (res) {
          this.successfulReg = true;
          this.errors = null;
        }
        this.hasErrors = false;
      },
      error: err => {      
        this.hasErrors = true;
        this.errors=err?.error?.errors || err?.error || err;
      }
    })
  }

  redirect() {
    this.router.navigate(['/login']);
  }
}
